enum CacheKeys {
  CACHE_ARTICLES = 'articles',
  CACHE_ARTICLES_PUBLIC_KEY = 'publicArticles',
  CACHE_ARTICLES_EN = 'articlesEn',
  CACHE_ARTICLES_PUBLIC_KEY_EN = 'publicArticlesEn',
  CACHE_BANNER = 'banner',
  CACHE_BANNER_PUBLIC = 'public-banner',
  CACHE_BANNER_FILE = 'MM-banner',
  CACHE_BECOME_SUSTAINABLE = 'becomeSustainable',
  CACHE_BECOME_SUSTAINABLE_EN = 'becomeSustainable-en'
}

export default CacheKeys
